import * as fromActions from '../actions';
import { FinanciadoresState } from "../models/store.models";

const initialState: FinanciadoresState = {
    financiadores: null
}

export function financiadoresReducer(state: FinanciadoresState = initialState, action: fromActions.FinanciadoresActions): FinanciadoresState {
    switch (action.type) {
        case fromActions.SET_FINANCIADOR:
            return {
                financiadores: action.financiadorSeteado
            }
        case fromActions.UNSET_FINANCIADOR:
            return {
                financiadores: null
            }
        case fromActions.UPDATE_FINANCIADORES:
            return {
                financiadores: action.financiadorActualizado
            }
        default:
            return state
    }
}
